import { Component, Input, Inject } from '@angular/core';
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: 'side-effect-fetch-FASummaryValues',
    templateUrl: './side-effect-fetch-FASummaryValues.component.html',
    standalone: false
})
export class SideEffectFetchFASummaryValuesComponent {
    _seConfiguration: any;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};
        this._seConfiguration.orgIdToFetchSummaryFor = this._seConfiguration.orgIdToFetchSummaryFor || '';

        this._seConfiguration.OrgIdContextTarget = this._seConfiguration.OrgIdContextTarget || '';
        this._seConfiguration.HistoricalOrgIdContextTarget = this._seConfiguration.HistoricalOrgIdContextTarget || '';

        this._seConfiguration.requiredFAContextTarget = this._seConfiguration.requiredFAContextTarget || '';
        this._seConfiguration.providedFAContextTarget = this._seConfiguration.providedFAContextTarget || '';

        this._seConfiguration.requiredInsuranceContextTarget = this._seConfiguration.requiredInsuranceContextTarget || '';
        this._seConfiguration.providedInsuranceContextTarget = this._seConfiguration.providedInsuranceContextTarget || '';

        this._seConfiguration.isBrineHaulerContextTarget = this._seConfiguration.isBrineHaulerContextTarget || '';
        this._seConfiguration.hasActiveFinancialStatementContextTarget = this._seConfiguration.hasActiveFinancialStatementContextTarget || '';

        this._seConfiguration.numberOfPostJune2010DomesticWellsContextTarget = this._seConfiguration.numberOfPostJune2010DomesticWellsContextTarget || '';
        this._seConfiguration.numberOfDomesticWellsSinceFinancialStatementReviewContextTarget = this._seConfiguration.numberOfDomesticWellsSinceFinancialStatementReviewContextTarget || '';
        
    }
    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.seConfiguration = data.configuration;
    }
}
